import React from 'react';

/** Compass mark for "career direction" (Heroicons has no compass). */
export function CompassIcon({ className = '' }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} className={className} aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M15.5 8.5l-2 5-5 2 2-5 5-2z" strokeLinejoin="round" />
        </svg>
    );
}
